import styled from "styled-components";

export const ResultsImagesLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;
  gap: 2rem;
  justify-content: space-between;
`;
